module.exports = __webpack_public_path__ + "static/media/1.da0801b3.jpg";